export default "__VITE_ASSET__CJeDRrxQ__"